import { createContext, useState } from "react";

export const TokenContext = createContext();

export const TokenProvider = ({ children }) => {
  const [token, setToken] = useState("");
  return (
    <TokenContext.Provider value={{ setToken, token }}>
      {children}
    </TokenContext.Provider>
  );
};
